import type { IOfferParams, IRatesChartEvent, ISendOfferParams } from './events';
import {
  eventOnSubmitOffer,
  eventOnChangeFilter,
  eventOnClickChangeLocation,
  eventOnClickFillManuallyButton,
  eventOnClickGosuslugiButton,
  eventOnClickOfferCard,
  eventOnContinueButton,
  eventShowLandingPage,
  eventPaidClick,
  eventSendOffer,
  eventOnClickApprovedOfferOnMplCreditSelectionScreen,
  eventOnClickWhyRefusedOffersOnMplCreditSelectionScreen,
  eventOnShowRefusedOffersOnMplCreditSelectionScreen,
  eventOnSubmitClickTopXOnMplCreditSelectionScreen,
  eventOnShowTopXOnMplCreditSelectionScreen,
  eventOnClickApprovalDateOnMplCreditSelectionScreen,
  eventOnClickChangeAmountOnMplCreditSelectionScreen,
  eventOnClickWhyThisAmountOnMplCreditSelectionScreen,
  eventOnShowApprovedOfferOnMplCreditSelectionScreen,
  eventOnCloseApprovedOffersPopupOnMplCreditSelectionScreen,
  eventOnShowApprovedOffersPopupOnMplCreditSelectionScreen,
  eventOnShowPDNOnMplOffersLoadingScreen,
  eventOnShowRatingDescriptionPopupOnMplOffersLoadingScreen,
  eventOnRatingDescriptionClickOnMplOffersLoadingScreen,
  eventOnShowMplOffersLoadingScreenStep,
  eventGoToOfferWebsite,
  eventChangeFilter,
  eventChangeLocation,
  eventAuthorizationSuccess,
  eventShowStep,
  eventRatesChartChange,
  eventRatesChartInit,
  eventRatesChartSelectItem,
  eventRatesChartViewItem,
  eventFillFormField,
  eventFormFieldError,
  eventInvalidForm,
  eventChangeFormFieldDefaultParam,
  eventGetCodeBySms,
  eventInvalidSmsCode,
  eventChangePhoneNumber,
  eventRequestNewCode,
  eventAuthorizationError,
  eventStepContacts,
  eventStepCreditPurpose,
  eventStepPassport,
  eventStepAdditionalData,
  eventStepWorkplace,
  eventEmptyOffers,
  eventShowOffers,
  eventOpenConsentsScreen,
  eventConsentsScreenButtonClick,
  eventOnDisableAgreementPersonalData,
  eventOnEnableAgreementAdvertising,
  eventShowFullDealBlock,
  eventApplyForLoan,
  eventLoanConditions,
  eventCancelSelection,
  eventSubmitFullDealApplication,
  eventMyApplications,
  eventButtonClick,
  eventValidationError,
  eventCloseSMSPopupClick,
  eventClickBiometry,
  eventShowBiometry,
  eventGoEsiaFromBiometry,
  eventFeedClick,
  eventFeedDecline,
  eventFeedSuccess,
  eventFeedFinishClick,
} from './events';
import { sendEventToGA } from './sendEventToGA';

export const sendEventPaidClick = (data: ISendOfferParams) => sendEventToGA(eventPaidClick(data));
export const sendEventOfferSent = (data: ISendOfferParams) => sendEventToGA(eventSendOffer(data));
export const sendEventRatesChartInit = (data: IRatesChartEvent) => sendEventToGA(eventRatesChartInit(data));
export const sendEventRatesChartChange = (label: string, value: string) =>
  sendEventToGA(eventRatesChartChange(label, value));

export const sendEventRatesChartViewItem = (label: string) => sendEventToGA(eventRatesChartViewItem(label));

export const sendEventRatesChartSelectItem = (label: string, data: IRatesChartEvent) =>
  sendEventToGA(eventRatesChartSelectItem(label, data));

export const sendEventFillFormField = (...args: Parameters<typeof eventFillFormField>) =>
  sendEventToGA(eventFillFormField(...args));

export const sendEventFormFieldError = (...args: Parameters<typeof eventFormFieldError>) =>
  sendEventToGA(eventFormFieldError(...args));

export const sendEventInvalidForm = (...args: Parameters<typeof eventInvalidForm>) =>
  sendEventToGA(eventInvalidForm(...args));

export const sendEventChangeFormFieldDefaultParam = (...args: Parameters<typeof eventChangeFormFieldDefaultParam>) =>
  sendEventToGA(eventChangeFormFieldDefaultParam(...args));

export const sendEventGetCodeBySms = () => sendEventToGA(eventGetCodeBySms());

export const sendEventInvalidSmsCode = () => sendEventToGA(eventInvalidSmsCode());

export const sendEventChangePhoneNumber = () => sendEventToGA(eventChangePhoneNumber());

export const sendEventRequestNewCode = () => sendEventToGA(eventRequestNewCode());

export const sendEventAuthorizationError = (...args: Parameters<typeof eventAuthorizationError>) =>
  sendEventToGA(eventAuthorizationError(...args));

export const sendEventAuthorizationSuccess = (...args: Parameters<typeof eventAuthorizationSuccess>) =>
  sendEventToGA(eventAuthorizationSuccess(...args));

export const sendEventStepContacts = (...args: Parameters<typeof eventStepContacts>) =>
  sendEventToGA(eventStepContacts(...args));

export const sendEventStepCreditPurpose = (...args: Parameters<typeof eventStepCreditPurpose>) =>
  sendEventToGA(eventStepCreditPurpose(...args));

export const sendEventStepPassport = (...args: Parameters<typeof eventStepPassport>) =>
  sendEventToGA(eventStepPassport(...args));

export const sendEventAdditionalData = (...args: Parameters<typeof eventStepAdditionalData>) =>
  sendEventToGA(eventStepAdditionalData(...args));

export const sendEventStepWorkplace = (...args: Parameters<typeof eventStepWorkplace>) =>
  sendEventToGA(eventStepWorkplace(...args));

export const sendEventShowStep = (...args: Parameters<typeof eventShowStep>) => sendEventToGA(eventShowStep(...args));

export const sendEventShowOffers = (...args: Parameters<typeof eventShowOffers>) =>
  sendEventToGA(eventShowOffers(...args));

export const sendEventEmptyOffers = (...args: Parameters<typeof eventEmptyOffers>) =>
  sendEventToGA(eventEmptyOffers(...args));

export const sendEventChangeLocation = () => sendEventToGA(eventChangeLocation());

export const sendEventChangeFilter = (label: string) => sendEventToGA(eventChangeFilter(label));

export const sendEventGoToOfferWebsite = (params: IOfferParams) => sendEventToGA(eventGoToOfferWebsite(params));

export const sendEventOpenConsentsScreen = () => sendEventToGA(eventOpenConsentsScreen());

export const sendEventConsentsScreenButtonClick = (...args: Parameters<typeof eventConsentsScreenButtonClick>) =>
  sendEventToGA(eventConsentsScreenButtonClick(...args));

export const sendEventOnDisableAgreementPersonalData = () => sendEventToGA(eventOnDisableAgreementPersonalData());

export const sendEventOnEnableAgreementAdvertising = () => sendEventToGA(eventOnEnableAgreementAdvertising());

export const sendEventOnShowMplOffersLoadingScreenStep = (
  ...args: Parameters<typeof eventOnShowMplOffersLoadingScreenStep>
) => sendEventToGA(eventOnShowMplOffersLoadingScreenStep(...args));

export const sendEventOnRatingDescriptionClickOnMplOffersLoadingScreen = (
  ...args: Parameters<typeof eventOnRatingDescriptionClickOnMplOffersLoadingScreen>
) => sendEventToGA(eventOnRatingDescriptionClickOnMplOffersLoadingScreen(...args));

export const sendEventOnShowRatingDescriptionPopupOnMplOffersLoadingScreen = (
  ...args: Parameters<typeof eventOnShowRatingDescriptionPopupOnMplOffersLoadingScreen>
) => sendEventToGA(eventOnShowRatingDescriptionPopupOnMplOffersLoadingScreen(...args));

export const sendEventOnShowPDNOnMplOffersLoadingScreen = (
  ...args: Parameters<typeof eventOnShowPDNOnMplOffersLoadingScreen>
) => sendEventToGA(eventOnShowPDNOnMplOffersLoadingScreen(...args));

export const sendEventOnShowApprovedOffersPopupOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnShowApprovedOffersPopupOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnShowApprovedOffersPopupOnMplCreditSelectionScreen(...args));

export const sendEventOnCloseApprovedOffersPopupOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnCloseApprovedOffersPopupOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnCloseApprovedOffersPopupOnMplCreditSelectionScreen(...args));

export const sendEventOnShowApprovedOfferOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnShowApprovedOfferOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnShowApprovedOfferOnMplCreditSelectionScreen(...args));

export const sendEventOnClickApprovedOfferOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnClickApprovedOfferOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnClickApprovedOfferOnMplCreditSelectionScreen(...args));

export const sendEventOnClickWhyThisAmountOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnClickWhyThisAmountOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnClickWhyThisAmountOnMplCreditSelectionScreen(...args));

export const sendEventOnClickChangeAmountOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnClickChangeAmountOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnClickChangeAmountOnMplCreditSelectionScreen(...args));

export const sendEventOnClickApprovalDateOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnClickApprovalDateOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnClickApprovalDateOnMplCreditSelectionScreen(...args));

export const sendEventOnShowTopXOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnShowTopXOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnShowTopXOnMplCreditSelectionScreen(...args));

export const sendEventOnSubmitClickTopXOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnSubmitClickTopXOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnSubmitClickTopXOnMplCreditSelectionScreen(...args));

export const sendEventOnShowRefusedOffersOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnShowRefusedOffersOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnShowRefusedOffersOnMplCreditSelectionScreen(...args));

export const sendEventOnClickWhyRefusedOffersOnMplCreditSelectionScreen = (
  ...args: Parameters<typeof eventOnClickWhyRefusedOffersOnMplCreditSelectionScreen>
) => sendEventToGA(eventOnClickWhyRefusedOffersOnMplCreditSelectionScreen(...args));

export const sendEventShowFullDealBlock = (...args: Parameters<typeof eventShowFullDealBlock>) =>
  sendEventToGA(eventShowFullDealBlock(...args));

export const sendEventApplyForLoan = (...args: Parameters<typeof eventApplyForLoan>) =>
  sendEventToGA(eventApplyForLoan(...args));

export const sendEventLoanConditions = (...args: Parameters<typeof eventLoanConditions>) =>
  sendEventToGA(eventLoanConditions(...args));

export const sendEventCancelSelection = (...args: Parameters<typeof eventCancelSelection>) =>
  sendEventToGA(eventCancelSelection(...args));

export const sendEventSubmitFullDealApplication = (...args: Parameters<typeof eventSubmitFullDealApplication>) =>
  sendEventToGA(eventSubmitFullDealApplication(...args));

export const sendEventMyApplications = (...args: Parameters<typeof eventMyApplications>) =>
  sendEventToGA(eventMyApplications(...args));

export const sendEventButtonClick = (...args: Parameters<typeof eventButtonClick>) =>
  sendEventToGA(eventButtonClick(...args));

export const sendEventValidationError = (...args: Parameters<typeof eventValidationError>) =>
  sendEventToGA(eventValidationError(...args));

export const sendEventCloseSMSPopupClick = () => sendEventToGA(eventCloseSMSPopupClick());

export const sendEventShowLandingPage = () => sendEventToGA(eventShowLandingPage());

export const sendEventOnClickChangeLocation = () => sendEventToGA(eventOnClickChangeLocation());

export const sendEventOnContinueButton = () => sendEventToGA(eventOnContinueButton());

export const sendEventOnClickFillManuallyButton = () => sendEventToGA(eventOnClickFillManuallyButton());

export const sendEventOnClickGosuslugiButton = () => sendEventToGA(eventOnClickGosuslugiButton());

export const sendEventOnClickOfferCard = (...args: Parameters<typeof eventOnClickOfferCard>) =>
  sendEventToGA(eventOnClickOfferCard(...args));

export const sendEventOnSubmitOffer = (...args: Parameters<typeof eventOnSubmitOffer>) =>
  sendEventToGA(eventOnSubmitOffer(...args));

export const sendEventOnChangeFilter = (...args: Parameters<typeof eventOnChangeFilter>) =>
  sendEventToGA(eventOnChangeFilter(...args));

export const sendEventClickBiometry = () => sendEventToGA(eventClickBiometry());

export const sendEventShowBiometry = () => sendEventToGA(eventShowBiometry());

export const sendEventGoEsiaFromBiometry = (...args: Parameters<typeof eventGoEsiaFromBiometry>) =>
  sendEventToGA(eventGoEsiaFromBiometry(...args));

export const sendEventFeedClick = (...args: Parameters<typeof eventFeedClick>) =>
  sendEventToGA(eventFeedClick(...args));

export const sendEventFeedDecline = (...args: Parameters<typeof eventFeedDecline>) =>
  sendEventToGA(eventFeedDecline(...args));

export const sendEventFeedSuccess = (...args: Parameters<typeof eventFeedSuccess>) =>
  sendEventToGA(eventFeedSuccess(...args));

export const sendEventFeedFinishClick = (...args: Parameters<typeof eventFeedFinishClick>) =>
  sendEventToGA(eventFeedFinishClick(...args));
